import { Controller, useFormContext } from 'react-hook-form'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { maxBirthdayDate, minBirthdayDate } from '../../../../utils/birthdayFromAge'
import type { UserFormValues } from '../ZodValidationSchema'

export const BirthdayField = () => {
  const { control } = useFormContext<UserFormValues>()

  return (
    <Controller
      name="birthday"
      control={control}
      render={({ field, fieldState }) => (
        <DatePicker
          format="DD.MM.YYYY"
          value={field.value}
          onChange={field.onChange}
          minDate={minBirthdayDate()}
          maxDate={maxBirthdayDate()}
          slotProps={{
            textField: {
              fullWidth: true,
              size: 'small',
              placeholder: 'Дата рождения',
              error: !!fieldState.error,
              helperText: fieldState.error?.message,
            },
          }}
        />
      )}
    />
  )
}
